import axios from "axios";

export function apiGetViews(instance, queryParams) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/views" + (queryParams ? "?" + queryParams : ""), {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetView(instance, id) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/views/" + id, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveView(instance, nom, body, id_process) {
  return axios
    .post(
      process.env.REACT_APP_URL_EXPRESS + "api/views",
      {
        nom,
        body,
        parent_process: id_process,
      },
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateView(id, nom, body) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/views/" + id, {
      nom,
      body,
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteView(id) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/views/" + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
